/**
 * Consistent store→color mapping for cross-store views (Explorer, timeline,
 * DAG). Kept in sync with CausalityDag's internal STORE_COLORS so the same
 * store renders the same color across the app.
 */
export const STORE_COLORS: Record<string, string> = {
  payments: '#0972d3',
  'risk-assessments': '#d91515',
  settlements: '#037f0c',
  alerts: '#ec7211',
};

export function colorForStore(store: string): string {
  return STORE_COLORS[store] || '#687078';
}

/**
 * All target-state stores the Explorer queries in parallel when a stream key
 * is entered. Order controls the "Recent Streams" panel column order.
 */
export const EXPLORER_STORES = ['payments', 'risk-assessments', 'settlements', 'alerts'] as const;
